export const searchByOptions = [
    {
        i18n: 'nav.enhanced_search.hints_details.installation_name',
        i18nFallback: 'Installation Name',
    },
    { i18n: 'nav.enhanced_search.hints_details.installation_id', i18nFallback: 'Installation ID' },
    { i18n: 'nav.enhanced_search.hints_details.vrm_portal_id', i18nFallback: 'VRM Portal ID' },
    {
        i18n: 'nav.enhanced_search.hints_details.user_email_address',
        i18nFallback: 'User email address',
    },
    {
        i18n: 'nav.enhanced_search.hints_details.device_serial',
        i18nFallback: 'Device serial number',
    },
    {
        i18n: 'nav.enhanced_search.hints_details.email_domain',
        i18nFallback: 'Email domain (e.g. "@maildomain.com")',
    },
];
